import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { Lightbox, LightboxType } from "../../../../../../react-core/Html/Components/Lightbox";
import { FormComponent } from "../../../../../../react-core/Html/FormComponent";
import { MoneyTextBoxEditor } from "../../../../../../react-core/Html/Money/MoneyTextBoxEditor";
import { CurrencyCode } from "../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { UserClientSummaryGroupSettingModel } from "../../../../../../Wrap/Models/Domains/Users/UserClientSummaryGroupSettingModel";

interface IEditRangePopupProps {
    data: UserClientSummaryGroupSettingModel;
    onSave: (setting) => void;
    isShow: boolean;
    onClose: () => void;
}

interface IEditRangePopupState {
    setting: number[];
}

export class EditRangePopup extends FormComponent<IEditRangePopupProps, IEditRangePopupState> {
    constructor(props: IEditRangePopupProps) {
        super(props);
        this.state = {
            setting: props.data.GroupStartValue.concat(),
        };
    }

    render() {
        const props = this.props;
        const setting = this.state.setting;
        return (
            <>
                {props.isShow && (
                    <Lightbox
                        show={props.isShow}
                        title={"Edit range"}
                        contentAfterTitle={null}
                        onClose={() => props.onClose()}
                        type={LightboxType.Modal}
                        unclosable={false}
                        noOverlay={false}
                        noAutofocus={false}
                        cssWrapper={"is-default-lightbox"}
                    >
                        {setting.map((ele, index) => {
                            return (
                                <div key={index} className="row">
                                    <span className="pt-40">{index == setting.length - 1 ? "> " : ""}</span>
                                    <div className="col-6">
                                        <MoneyTextBoxEditor
                                            label={`Group ${index + 1} From`}
                                            onChange={(v) => {
                                                const _data = setting.concat();
                                                _data[index] = v;
                                                this.setState({ setting: _data });
                                            }}
                                            validationRules={[
                                                {
                                                    errorMessage:
                                                        "Value must be greater that the previous Groups 'From' amount",
                                                    validator: (v) => {
                                                        if (index == 0) {return true;}
                                                        return v > setting[index - 1] + 0.01;
                                                    },
                                                },
                                            ]}
                                            disabled={index == 0}
                                            value={ele}
                                            required="Please enter"
                                            currency={CurrencyCode.GBP}
                                        />
                                    </div>
                                    {index == setting.length - 1 ? null : (
                                        <div className="col-6">
                                            <MoneyTextBoxEditor
                                                label={`To`}
                                                onChange={(v) => {}}
                                                value={Number((setting[index + 1] - 0.01).toFixed(2))}
                                                disabled
                                                currency={CurrencyCode.GBP}
                                            />
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                        <button className="btn secondary mr-10" onClick={() => props.onClose()}>
                            Cancel
                        </button>
                        <button
                            className="btn secondary mr-10"
                            onClick={() => {
                                props.onClose();
                                props.onSave({ GroupStartValue: [0, 100000, 250000, 500000, 750000, 1000000] });
                            }}
                        >
                            Apply default
                        </button>
                        <button
                            className="btn primary mr-10"
                            onClick={() => {
                                if (this.isValid()) {
                                    props.onClose();
                                    props.onSave({ GroupStartValue: setting });
                                }
                            }}
                        >
                            Save
                        </button>
                    </Lightbox>
                )}
            </>
        );
    }
}
